export interface TestStripeConnectionResponse {
    customers: any[];
    groupIdFound: boolean;
    missingEntities: string[];
    customerMetaDataKeys?: string[];
    __typename: string;
}

export const DEMO_TEST_SCENARIOS = {
    SUCCESS: {
        customers: [],
        groupIdFound: true,
        missingEntities: [],
        customerMetaDataKeys: ['group_id', 'account_id', 'organization_id', 'tenant_id'], 
        __typename: "TestStripeConnectionResponse"
    },
    MISSING_ENTITIES: {
        customers: [
            { id: 'cus_demo_1', metadata: '{"group_id":"demo_account_1","organization_id":"org_1"}' },
            { id: 'cus_demo_2', metadata: '{"group_id":"demo_account_2","account_id":"acct_2"}' },
        ],
        groupIdFound: true,
        missingEntities: [
            "products",
            "subscriptions",
            "subscription_items",
            "balance_transactions",
            "transactions",
            "charges",
            "disputes"
        ],
        customerMetaDataKeys: ['group_id', 'account_id', 'organization_id'],
        __typename: "TestStripeConnectionResponse"
    },
    MISSING_GROUP_ID: {
        customers: [],
        groupIdFound: false,
        missingEntities: [],
        customerMetaDataKeys: ['account_id', 'organization_id', 'tenant_id', 'company_id'], 
        __typename: "TestStripeConnectionResponse"
    },
    NO_METADATA_KEYS: { 
        customers: [],
        groupIdFound: false,
        missingEntities: [],
        customerMetaDataKeys: [], 
        __typename: "TestStripeConnectionResponse"
    }
};

export const simulateTestStripeConnection = async (
    scenario: keyof typeof DEMO_TEST_SCENARIOS
): Promise<TestStripeConnectionResponse> => {
    await new Promise(resolve => setTimeout(resolve, 500));
    return DEMO_TEST_SCENARIOS[scenario];
};

export const simulateCreateStripeIntegration = async (input: any) => {
    await new Promise(resolve => setTimeout(resolve, 3000));
    
    return {
        sourceId: `demo_source_${Date.now()}`,
        connectionId: `demo_conn_${Date.now()}`,
        syncStartedAt: new Date().toISOString(),
        syncStatus: 'succeeded',
        jobId: Math.floor(Math.random() * 10000)
    };
};

export const DEMO_ENVIRONMENT = {
    id: 'demo_env_development',
    displayName: 'Development',
    name: 'development',
    environmentType: 'NON_PRODUCTION'
};